var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"image"},[_c('img',{staticClass:"is-rounded has-shadow",style:({
      backgroundImage: _vm.mImageSrc,
      backgroundColor: _vm.chosenRandomColor
    }),attrs:{"src":"/img/spacer1_1.gif","alt":_vm.itemName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }